import { render, staticRenderFns } from "./LegalSidebar.vue?vue&type=template&id=57f8ede0&"
import script from "./LegalSidebar.vue?vue&type=script&lang=js&"
export * from "./LegalSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports